// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckField_root__3BRDE","field":"CheckField_field__13_bU","fieldLabel":"CheckField_fieldLabel__QMtT9"};